import styled from 'styled-components';

import {
  grey1,
  grey5,
  grey9,
  coolGrey1,
  azure7,
} from 'approot/shared/styles/colours.style';
import { rem } from 'approot/shared/style';
import { fontWeightMedium } from 'approot/shared/styles/typography.style';
import { spacing16, spacing8 } from 'approot/shared/styles/spacing.style';
import {
  RichtextProps,
  richtextCommonCss,
} from 'approot/shared/richtext/richtext.style';
import { getLineMinHeight } from 'approot/activity-builder/theme/activity-builder-theme.utils';

export const Table = styled.table`
  border-collapse: collapse;
  table-layout: fixed;
  position: relative;
  width: 100%;
`;

export const TableRow = styled.tr``;

type HighlightProps = {
  $highlight?: boolean;
};

export const TableCell = styled.td.attrs<HighlightProps>(({ $highlight }) => ({
  as: $highlight ? 'th' : 'td',
}))<HighlightProps>`
  border: 1px solid ${grey5};
  background-color: ${({ $highlight }) => ($highlight ? coolGrey1 : grey1)};
  margin: 0;
  padding: ${rem(2)};
  text-align: left;

  .ProseMirror {
    border: 1px solid ${({ $highlight }) => ($highlight ? coolGrey1 : grey1)};
    border-radius: 0;
    ${props =>
      props.$highlight &&
      `
        p {
          font-weight: ${fontWeightMedium};
        }
    `}
  }
`;

export const TableCellView = styled.div.attrs<
  HighlightProps &
    RichtextProps & {
      $rows?: number;
      $baseLineHeight?: number;
      $baseFontSize: number;
      $isAnswer?: boolean;
    }
>({
  $isSmall: true,
})`
  box-sizing: border-box;
  border: 1px solid ${({ $highlight }) => ($highlight ? coolGrey1 : grey1)};
  color: ${({ $isAnswer }) => ($isAnswer ? azure7 : grey9)};
  height: 100%;
  ${({ $baseLineHeight, $baseFontSize, $rows }) =>
    $rows &&
    $baseLineHeight &&
    `
    // the 18px is 8px top padding + 8px bottom padding + 2px borders 
    min-height: ${rem(
      $rows > 1 ? $baseLineHeight * $rows + 18 : getLineMinHeight($baseFontSize)
    )};
  `}
  padding: ${rem(spacing8)} ${rem(spacing16)};

  ${richtextCommonCss}

  p {
    color: ${({ $isAnswer }) => ($isAnswer ? azure7 : grey9)};
  }

  ${props =>
    props.$highlight &&
    `
      p {
        font-weight: ${fontWeightMedium};
      }
  `}
`;
